<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="頻道" label-width="50px">
              <el-select
                size="small"
                v-model="queryForm.chnl"
                class="selectqry"
              >
                <el-option
                  v-for="item in myChnls"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                 <el-tooltip v-if="item.isSystem" content="系統頻道，勿公開、勿分享">
                <i class="el-icon-setting">{{ item.name }}</i>
               </el-tooltip>
                <span v-else
                  >{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
                style="width:90px"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-lock"
            @click="setEncrypt"
            :disabled="parentIsEncrypt || isExtChnl || parentSource != 0"
          ></el-button>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-top"
            @click="gotoFolder(null)"
            :disabled="!canGoUpFolder()"
            >回上一層</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewFolder"
            size="small"
            :disabled="isExtChnl || parentSource != 0"
            >新增資料夾</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-upload"
            @click="uploadItem"
            size="small"
            :disabled="isExtChnl || parentSource != 0"
            >上傳檔案</el-button
          >

          <el-button
            v-if="isSystemChannel && isWeatherFolder"
            type="success"
            icon="el-icon-cloudy"
            @click="openWeatherDlg"
            size="small"
            >新增天氣預報</el-button
          >
          <el-button
            v-if="isSystemChannel && isSlideshowFolder"
            type="success"
            icon="el-icon-magic-stick"
            @click="openSlideshowDlg"
            size="small"
            >產生待機腳本</el-button
          >

          <!--<el-button-->
          <!--size="small"-->
          <!--type="primary"-->
          <!--@click="batchGrantAssets"-->
          <!--:disabled="isGlobalChnlMgmt() || !enableAssign || selectedRow.length === 0 || !anySelectedGrantable" >批次個人授權</el-button >-->

          <el-button
            size="small"
            type="primary"
            @click="copySelectedItems"
            :disabled="selectedRow.length === 0 || isExtChnl"
            >批次複製</el-button
          >

          <el-button
            size="small"
            type="primary"
            @click="moveSelectedItems"
            :disabled="selectedRow.length === 0 || isExtChnl"
            >批次移動</el-button
          >

          <el-button
            size="small"
            type="danger"
            @click="delSelectedItems"
            :disabled="selectedRow.length === 0 || isExtChnl"
            >批次刪除</el-button
          >

          <el-button type="primary" @click="exportAssets" size="small"
            >匯出音檔清單</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader class="py-0">
        <CRow>
          <div class="container" style="margin:0">
            <div class="row ">
              <div class="headerpanel">
                <CIcon name="cib-apple-podcasts" class="headericon" />
              </div>

              <div class="ml-4">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item
                    v-for="(node, idx) in folderTree"
                    :key="`node_{${node.assetId}}`"
                  >
                    <el-button
                      type="text"
                      :disabled="isLeafNode(idx)"
                      @click="handleNodeClk(idx)"
                      >{{ node.assetName }}
                      <span v-if="node.isChannel && node.isPublic">(公開)</span>
                      <span v-if="node.isChannel && !node.isPublic"
                        >(非公開)</span
                      >
                      <i v-if="node.assetIsEncrypt" class="el-icon-lock"></i>
                    </el-button>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            ref="dataTable"
            v-loading="isLoading"
            :data="assets"
            @sort-change="sortChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            @row-dblclick="handleRowDbClk"
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              width="45"
              :selectable="rowSelectable"
            >
            </el-table-column>

            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <el-table-column
              label="名稱"
              prop="name"
              sortable="custom"
              width="330"
            >
              <template #default="scope">
                <img
                  v-if="!scope.row.isLeaf"
                  src="./../assets/icons/folder.svg"
                  class="foldericon"
                />
                <img v-else src="./../assets/icons/file.svg" class="fileicon" />
                <!--<i v-if="!scope.row.isLeaf" class="el-icon-folder"></i>-->
                <!--<i v-else class="el-icon-document"></i>-->

                <span class="ml-3">
                  {{ scope.row.name }}
                </span>
                <el-popover
                  v-if="scope.row.isEncrypt"
                  title="失效日"
                  width="200"
                  trigger="hover"
                >
                  <span v-if="scope.row.encryptExpiredMode == 'absolute'">
                    {{ convertTime(new Date(parseInt(scope.row.endDate))) }}
                  </span>
                  <span v-else
                    >下載後 {{ scope.row.endDateAmount }}
                    {{ formatDateUnit(scope.row.endDateUnit) }}</span
                  >

                  <i slot="reference" class="el-icon-lock"></i>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              label="上次修改時間"
              prop="lastUpdateDate"
              sortable="custom"
              width="200"
            >
              <template #default="scope">
                {{ convertTime(scope.row.lastUpdateDate) }}
              </template>
            </el-table-column>

            <el-table-column label="大小" prop="size" width="100">
              <template #default="scope">
                <div v-if="scope.row.isLeaf">
                  {{ getReadableSize(scope.row.size) }}
                </div>
                <!--<div v-else-if="scope.row.size !== null">-->
                <div
                  v-else-if="scope.row.size !== null"
                  style="word-break: keep-all"
                >
                  {{ scope.row.size }}
                </div>
                <div v-else>
                  <img
                    src="./../assets/icons/info.svg"
                    class="infoicon"
                    @click="getFolderSize(scope.row, scope.$index)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="備註"
              prop="description"
              width="200"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  size="mini"
                  @click="editAssetName(scope.row)"
                  :disabled="isExtChnl || rowIsReadOnly(scope.row)"
                  >編輯
                </el-button>

                <el-button
                  type="danger"
                  size="mini"
                  @click="delAsset(scope.row.id)"
                  :disabled="isExtChnl || rowIsReadOnly(scope.row)"
                  >刪除
                </el-button>

                <el-button
                  size="mini"
                  @click="copyAsset(scope.row)"
                  :disabled="isExtChnl || rowIsReadOnly(scope.row)"
                  >複製
                </el-button>

                <el-button
                  size="mini"
                  @click="moveAsset(scope.row)"
                  :disabled="isExtChnl || rowIsReadOnly(scope.row)"
                  >移動
                </el-button>

                <el-tooltip content="下載"
                  ><el-button
                    size="mini"
                    icon="el-icon-download"
                    @click="downloadAsset(scope.row)"
                  ></el-button
                ></el-tooltip>

                <!--<el-button-->
                <!--v-if="enableAssign && !isGlobalChnlMgmt()"-->
                <!--size="mini"-->
                <!--@click="grantAsset(scope.row)" >個人授權-->
                <!--</el-button>-->

                <el-button
                  v-if="isAssetPlayable(scope.row)"
                  size="mini"
                  @click="playAsset(scope.row)"
                  >播放
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <ChnlExportAssetDlg
          v-model="isExportDlgVisible"
          :key="`export_${exportDlgKey}`"
        ></ChnlExportAssetDlg>

        <ChnlCopyAssetDlg
          v-model="isCopyDlgVisible"
          :assetIds="selectAssetIds"
          :channelId="activeQueryForm.chnl"
          :srcFolderTree="srcFolderTree"
          @dialogClosed="handleCopyMoveDlgClosed"
          :key="`copy_${copyDlgKey}`"
        ></ChnlCopyAssetDlg>

        <ChnlMoveAssetDlg
          v-model="isMoveDlgVisible"
          :assetIds="selectAssetIds"
          :channelId="activeQueryForm.chnl"
          :srcFolderTree="srcFolderTree"
          @dialogClosed="handleCopyMoveDlgClosed"
          :key="`move_${moveDlgKey}`"
        ></ChnlMoveAssetDlg>

        <ChannelGrantDlg
          v-model="isGrantDlgVisible"
          :assetIds="selectAssetIds"
          :channelId="activeQueryForm.chnl"
          :assetName="selAssetName"
          :channelName="selChnlName"
          :key="`grant_${grantDlgKey}`"
        ></ChannelGrantDlg>

        <PlayerDlg
          v-model="isPlayDlgVisible"
          :assetName="selAssetName"
          :selectedItemId="selectedItemId"
          :key="`play_${playDlgKey}`"
        ></PlayerDlg>

        <AddEdtAssetDlg
          v-model="isDlgVisible"
          :selectedItemId="selectedItemId"
          :parentId="parentId"
          :isFolder="isSelectedFolder"
          :key="`addEdtAsset_${dlgKey}`"
        ></AddEdtAssetDlg>

        <UploadAssetDlg
          v-model="isUploadDlgVisible"
          :parentId="parentId"
          :key="`uploadDlg_${uploadDlgKey}`"
        ></UploadAssetDlg>

        <AddWeatherAssetDlg
          v-model="isWeatherDlgVisible"
          :parentId="parentId"
          :selectedItemId="selectedItemId"
          @success="refreshContent"
          :key="`weatherDlg_${weatherDlgKey}`"
        ></AddWeatherAssetDlg>

        <AddSlideshowAssetDlg
          v-model="isSlideshowDlgVisible"
          :parentId="parentId"
          @success="refreshContent"
          :key="`slideshowDlg_${slideshowDlgKey}`"
        ></AddSlideshowAssetDlg>

        <SetEncryptDlg
          v-model="isSetEncryptDlgVisible"
          :selectedRows="selectedRow"
        ></SetEncryptDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import appConfig from "@/appConfig";
import AddEdtAssetDlg from "@/components/channel/AddEdtAssetDlg";
import AddWeatherAssetDlg from "@/components/channel/AddWeatherAssetDlg";
import AddSlideshowAssetDlg from "@/components/channel/AddSlideshowAssetDlg";
import PlayerDlg from "@/components/channel/PlayerDlg";
import ChnlExportAssetDlg from "@/components/channel/ChnlExportAssetDlg";
import SetEncryptDlg from "@/components/channel/SetEncryptDlg";
import ChannelGrantDlg from "@/components/channel/ChannelGrantDlg";
import UploadAssetDlg from "@/components/channel/UploadAssetDlg";
import ChnlCopyAssetDlg from "@/components/channel/ChnlCopyAssetDlg";
import ChnlMoveAssetDlg from "@/components/channel/ChnlMoveAssetDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import moment from "moment-timezone";
import API from "@/api/";
export default {
  name: "orgChnlList",
  mixins: [tagColorsMixin],
  components: {
    SetEncryptDlg,
    AddEdtAssetDlg,
    AddWeatherAssetDlg,
    AddSlideshowAssetDlg,
    PlayerDlg,
    ChannelGrantDlg,
    UploadAssetDlg,
    ChnlExportAssetDlg,
    ChnlCopyAssetDlg,
    ChnlMoveAssetDlg,
  },
  created() {
    this.$store.commit("asset/CLEAR");
    API.my.channels().then(res => {
      this.myChnls = res.data;
      this.queryForm.chnl = res.data[0].id;
      this.activeQueryForm.chnl = res.data[0].id;

      this.getChannelAsset();
    });
  },
  data() {
    return {
      isPublic: true,
      selectAssetIds: [],
      enableAssign: false,
      selectedRow: [],
      selectedItemId: null,
      isLoading: false,
      parentId: null,
      isSelectedFolder: false,
      selChnlName: "",
      selAssetName: "",
      folderTree: [],
      srcFolderTree: [],
      musicAssetId: null,
      myChnls: [],
      dlgKey: 0,
      playDlgKey: 0,
      grantDlgKey: 0,
      copyDlgKey: 0,
      moveDlgKey: 0,
      uploadDlgKey: 0,
      exportDlgKey: 0,
      weatherDlgKey: 0,
      slideshowDlgKey: 0,
      isDlgVisible: false,
      isPlayDlgVisible: false,
      isGrantDlgVisible: false,
      isCopyDlgVisible: false,
      isMoveDlgVisible: false,
      isExportDlgVisible: false,
      isEdtChnlAdmDlgVisible: false,
      isUploadDlgVisible: false,
      isSetEncryptDlgVisible: false,
      isWeatherDlgVisible: false,
      isSlideshowDlgVisible: false,
      pageSize: 10,
      queryForm: {
        qstr: "",
        chnl: undefined,
      },
      activeQueryForm: {
        qstr: "",
        chnl: undefined,
      },
    };
  },
  methods: {
    handleCopyMoveDlgClosed() {
      const idx = this.folderTree.length - 1;
      this.gotoFolder(idx);
    },
    moveAsset(item) {
      const dlgFolderTree = this.folderTree.map(item => ({...item}))
      dlgFolderTree.splice(1, 0, {
        assetId: this.$store.state.asset.musicAssetId,
        assetName: appConfig.ASSET_ROOT_FOLDER,
      });
      dlgFolderTree[0].assetId = this.$store.state.asset.rootAssetId;
      this.srcFolderTree = dlgFolderTree;

      this.selectAssetIds = [item.id];
      this.moveDlgKey = this.moveDlgKey ? 0 : 1;
      this.isMoveDlgVisible = true;
    },
    copyAsset(item) {
      const dlgFolderTree = this.folderTree.map(item => ({...item}))
      dlgFolderTree.splice(1, 0, {
        assetId: this.$store.state.asset.musicAssetId,
        assetName: appConfig.ASSET_ROOT_FOLDER,
      });
      dlgFolderTree[0].assetId = this.$store.state.asset.rootAssetId;
      this.srcFolderTree = dlgFolderTree;

      this.selectAssetIds = [item.id];
      this.copyDlgKey = this.copyDlgKey ? 0 : 1;
      this.isCopyDlgVisible = true;
    },
    getFolderSize(asset, idx) {
      this.isLoading = true;
      API.asset
        .getAssetSize(asset.id)
        .then(res => {
          const { size, count } = res.data;
          console.log(`getFolderSize: size = ${size}, count = ${count}`);

          const newAsset = { ...asset };
          newAsset.size = `${this.getReadableSize(size)}/ ${count}個檔案`;

          const payload = {
            newElem: newAsset,
            index: idx,
          };
          this.$store.commit("asset/CHANGE_ELEMENT", payload);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getReadableSize(bytes, decimals = 2) {
      if (bytes == 0) return "0 Byte";
      var base = 1024,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(base));
      return (
        parseFloat((bytes / Math.pow(base, i)).toFixed(decimals)) +
        " " +
        sizes[i]
      );
    },
    rowSelectable(row) {
      return row.source == 0 || row.source == 2 || row.source == 3;
    },
    rowIsReadOnly(row) {
      return row.source != 0 && row.source != 2 && row.source != 3;
    },
    exportAssets() {
      this.exportDlgKey = this.exportDlgKey ? 0 : 1;
      this.isExportDlgVisible = true;
    },

    isFilePlayable(fileName) {
      const playableExt = appConfig.PLAYABLE_EXT;
      const ext =
        fileName.indexOf(".") > -1
          ? fileName
              .split(".")
              .pop()
              .toLowerCase()
          : "";
      return playableExt.some(item => item === ext);
    },
    isAssetPlayable(item) {
      if (!item.isLeaf) {
        return false;
      } else {
        return this.isFilePlayable(item.name);
      }
    },
    isGlobalChnlMgmt() {
      return this.myownOrg === appConfig.SYS_ORG_NAME ? true : false;
    },
    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },
    formatDateUnit(unit) {
      switch (unit) {
        case "years":
          return "年";
        case "months":
          return "月";
        case "days":
          return "日";
      }
    },
    convertTime(tm) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment(tm)
        .tz(tz)
        .format("YYYY-MM-DD hh:mm:ss A");
    },
    isLeafNode(idx) {
      return idx === this.folderTree.length - 1 ? true : false;
    },
    handleNodeClk(idx) {
      this.gotoFolder(idx);
    },
    canGoUpFolder() {
      const idx = this.folderTree.length - 2;
      return idx >= 0 ? true : false;
    },
    //NOTE: if idx is null, go 1 level folder up
    gotoFolder(idx) {
      if (idx == null) {
        idx = this.folderTree.length - 2;
      }
      if (idx >= 0) {
        //console.log(`gotoFolder: folderTree = ${JSON.stringify(this.folderTree)}`)

        const target = this.folderTree[idx];
        //console.log(`gotoFolder: target = ${JSON.stringify(target)}`)
        const removeNodes = this.folderTree.splice(idx + 1);
        this.$store.commit("asset/setParentIsEncrypt", target.isEncrypt);
        this.$store.commit("asset/setParentSource", target.source);
        //const curNode = this.folderTree.pop();
        this.getAssetContent(this.sort, this.order, {
          parent: target.assetId,
        }).catch(() => {
          this.folderTree = this.folderTree.concat(removeNodes);
          //this.folderTree.push(curNode);
        });
      }
    },
    getChnlName(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.name : "";
    },
    getChnlEnableAssign(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.enableAssign : false;
    },
    getChnlIsPublic(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl.isPublic;
    },
    handleRowDbClk(row) {
      //console.log(`handleRowDbClk: row = ${JSON.stringify(row)}`);
      //console.log(`handleRowDbClk: column = ${JSON.stringify(column)}`);
      if (!row.isLeaf) {
        this.$store.commit("asset/setParentIsEncrypt", row.isEncrypt);
        this.$store.commit("asset/setParentSource", row.source);
        this.folderTree.push({
          assetId: row.id,
          assetName: row.name,
          assetIsEncrypt: row.isEncrypt,
          source: row.source,
        });
        this.getAssetContent(this.sort, this.order, { parent: row.id }).catch(
          () => {
            this.folderTree.pop();
          }
        );
      }
    },
    uploadItem() {
      this.parentId = this.$store.state.asset.parent;
      this.uploadDlgKey = this.uploadDlgKey ? 0 : 1;
      this.isUploadDlgVisible = true;
    },
    addNewFolder() {
      this.parentId = this.$store.state.asset.parent;
      this.isSelectedFolder = true;
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },

    batchGrantAssets() {
      const assetIds = this.selectedRow.map(row => row.id);
      this.selectAssetIds = assetIds;
      this.selAssetName = "(多個檔案)";
      this.selChnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.grantDlgKey = this.grantDlgKey ? 0 : 1;
      this.isGrantDlgVisible = true;
      this.$refs.dataTable.clearSelection();
    },

    grantAsset(item) {
      this.selectAssetIds = [item.id];
      this.selAssetName = item.name;
      this.selChnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.grantDlgKey = this.grantDlgKey ? 0 : 1;
      this.isGrantDlgVisible = true;
    },
    playAsset(item) {
      this.selectedItemId = item.id;
      this.selAssetName = item.name;
      this.playDlgKey = this.playDlgKey ? 0 : 1;
      this.isPlayDlgVisible = true;
    },
    editAssetName(item) {
      this.selectedItemId = item.id;
      if (item.source === 2) {
        this.weatherDlgKey = this.weatherDlgKey ? 0 : 1;
        this.isWeatherDlgVisible = true;
      } else {
        this.isSelectedFolder = !item.isLeaf;
        this.dlgKey = this.dlgKey ? 0 : 1;
        this.isDlgVisible = true;
      }
    },
    setEncrypt() {
      this.isSetEncryptDlgVisible = true;
    },
    openWeatherDlg() {
      this.selectedItemId = null;
      const len = this.folderTree.length;
      this.parentId = len > 0 ? this.folderTree[len - 1].assetId : this.$store.state.asset.parent;
      this.weatherDlgKey = this.weatherDlgKey ? 0 : 1;
      this.isWeatherDlgVisible = true;
    },
    openSlideshowDlg() {
      this.selectedItemId = null;
      const len = this.folderTree.length;
      this.parentId = len > 0 ? this.folderTree[len - 1].assetId : this.$store.state.asset.parent;
      this.slideshowDlgKey = this.slideshowDlgKey ? 0 : 1;
      this.isSlideshowDlgVisible = true;
    },
    refreshContent() {
      const idx = this.folderTree.length - 1;
      this.gotoFolder(idx);
    },
    handleQueryClick(queryForm) {
      const queryNewChnl = queryForm.chnl !== this.activeQueryForm.chnl;
      this.activeQueryForm = { ...queryForm };
      if (queryNewChnl) {
        this.getChannelAsset(queryForm);
      } else {
        const newParams = { ...queryForm };
        delete newParams.chnl;
        this.getAssetContent(this.sort, this.order, newParams);
      }
    },

    //NOTE: params is used to assign qstr; channelId is given by activeQueryForm.chnl
    getChannelAsset(params = {}) {
      this.folderTree = [];
      const chnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.enableAssign = this.getChnlEnableAssign(this.activeQueryForm.chnl);
      this.isPublic = this.getChnlIsPublic(this.activeQueryForm.chnl);
      this.isLoading = true;
      this.$store
        .dispatch("asset/getChannelAsset", {
          channelId: this.activeQueryForm.chnl,
          sort: this.sort,
          order: this.order,
          ...params,
        })
        .then(res => {
          this.folderTree.push({
            assetId: this.$store.state.asset.parent,
            assetName: chnlName,
            isChannel: true,
            isPublic: this.isPublic,
            source: 0,
          });
          //console.log(`getChannelAsset then: folderTree = ${JSON.stringify(this.folderTree)}`)
          return res;
        })
        .catch(err => {
          console.log(`getChannelAsset err = ${err}`);
          this.folderTree.push({ assetId: null, assetName: chnlName });
          //console.log(`getChannelAsset catch: folderTree = ${JSON.stringify(this.folderTree)}`)
          return err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //NOTE: if parent is assigned in params, it will get content for another asset;
    //    Otherwise, it will just query for the current parent asset
    getAssetContent(sort, order, params = {}) {
      this.isLoading = true;
      return this.$store
        .dispatch("asset/getAssetContent", {
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    indexFormatter(index) {
      return `#${index + 1}`;
    },
    moveSelectedItems() {
      this.selectAssetIds = this.selectedRow.map(row => row.id);
      this.moveDlgKey = this.moveDlgKey ? 0 : 1;
      this.isMoveDlgVisible = true;
    },
    copySelectedItems() {
      this.selectAssetIds = this.selectedRow.map(row => row.id);
      this.copyDlgKey = this.copyDlgKey ? 0 : 1;
      this.isCopyDlgVisible = true;
    },
    delSelectedItems() {
      this.$confirm("此操作將永久刪除選取的項目, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isLoading = true;
        const promises = this.selectedRow.map(row => API.asset.remove(row.id));
        Promise.all(promises).finally(() => {
          this.isLoading = false;
          this.getAssetContent(this.sort, this.order, this.activeQueryForm);
        });
      });
    },
    downloadAsset(item) {
      const baseURL = process.env.VUE_APP_APIURL
        ? process.env.VUE_APP_APIURL
        : window.location.origin.replace("//admin.", "//api.") + "/";
      let finalUrl = `${baseURL}asset2/download/${item.id}?token=${encodeURI(
        this.$store.state.auth.access_token
      )}`;
      const link = document.createElement("a");
      document.body.appendChild(link);
      link.href = finalUrl;
      link.setAttribute("type", "hidden");
      link.click();
    },
    delAsset(itemId) {
      this.$confirm("此操作將永久刪除該項目, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.asset.remove(itemId).then(() => {
            this.getAssetContent(this.sort, this.order, this.activeQueryForm);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("asset/SET_SORT", "id");
        this.$store.commit("asset/SET_ORDER", "ascending");
      } else {
        this.$store.commit("asset/SET_SORT", args.prop);
        this.$store.commit("asset/SET_ORDER", args.order);
      }
      this.getAssetContent(this.sort, this.order, this.activeQueryForm);
    },
  },
  computed: {
    anySelectedGrantable() {
      return this.selectedRow.some(() => true);
    },
    isSystemChannel() {
      if (this.activeQueryForm.chnl) {
        const foundChnl = this.myChnls.find(
          chnl => chnl.id === this.activeQueryForm.chnl
        );
        return foundChnl ? foundChnl.isSystem : false;
      }
      return false;
    },
    isWeatherFolder() {
      const len = this.folderTree.length;
      if (len < 2) return false;
      return (
        this.folderTree[len - 1].assetName === "weather" &&
        this.folderTree[len - 2].assetName === "Photo"
      );
    },
    isSlideshowFolder() {
      const len = this.folderTree.length;
      if (len < 1) return false;
      return this.folderTree[len - 1].assetName === "Slideshow";
    },
    isExtChnl() {
      if (this.activeQueryForm.chnl) {
        const foundChnl = this.myChnls.find(
          chnl => chnl.id === this.activeQueryForm.chnl
        );
        return (foundChnl.parent ? true : false) || foundChnl.isReadOnly;
      }
      return false;
    },
    parentSource() {
      return this.$store.state.asset.parentSource;
    },
    ...mapGetters({
      parentIsEncrypt: "asset/parentIsEncrypt",
      myownOrg: "auth/orgName",
      assets: "asset/assets",
      total: "asset/total",
      sort: "asset/sort",
      order: "asset/order",
    }),
  },
};
</script>

<style>
.foldericon {
  width: 20px;
  height: 20px;
  margin-right: -7px;
}
.fileicon {
  width: 24px;
  height: 24px;
  margin-left: -2px;
  margin-right: -7px;
}
.funcpanel {
  padding-top: 6px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 1.5rem;
}
.selectqry {
  width: 12rem;
}
</style>
